export enum NotificationStatusEnum{
    OPEN ='OPEN',
    FAILED ='FAILED',
    NOTIFIED ='NOTIFIED',
}